import axios from "axios";
import { useAuthStatus } from "./stores/auth-store";

const api = axios.create();
api.defaults.baseURL = `${import.meta.env.VITE_LARAVEL_API_URL}/api/v1` as string;

// Request interceptor for API calls
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("lt");

    config.headers.set("Authorization", `Bearer ${token ? token : ""}`);
    config.headers.set("Accept", "application/json");
    config.headers.set("Content-Type", "application/json");
    return config;
  },
  (error) => {
    console.error("REFRESH FAILED : REDIRECT TO LOGOUT");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("lt");
    useAuthStatus.setState({ isLoggedIn: false });
    return Promise.reject(error);
  },
);

// Response interceptor : un token Sanctum invalide/revoque (401) deconnecte
// immediatement l'utilisateur et le renvoie vers /login.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("lt");
      useAuthStatus.setState({ isLoggedIn: false });
    }
    return Promise.reject(error);
  },
);

export default api;
